<div class="overlay"></div>
<div class="panel">
  <div class="inside-panel">
    <header>
      <h2>{{ newInvoicePanelTitle }}</h2>
    </header>
    <form [formGroup]="invoiceForm">
      <!-- Dati Documento Section -->
      <section class="dati-documento">
        <h3>Dati Documento</h3>
        <div class="document-grid">
          <div class="document-row">
            <mat-form-field>
              <mat-label>Tipo</mat-label>
              <mat-select formControlName="tipo">
                <mat-option value="Parcella SDI">Parcella SDI</mat-option>
                <mat-option value="Nota di Credito SDI"
                  >Nota di Credito SDI</mat-option
                >
              </mat-select>
            </mat-form-field>

            <mat-form-field>
              <mat-label>Azienda</mat-label>
              <input
                matInput
                [formControlName]="'cliente'"
                [matAutocomplete]="clientAuto"
                (focus)="showAllClients()"
                (input)="filterClients($event)"
                (blur)="onClientBlur()"
                [disabled]="!selectedClientType"
              />
              <mat-autocomplete #clientAuto="matAutocomplete">
                @for (client of filteredCompanyClients; track client) {
                  <mat-option
                    [value]="client.company_name"
                    (onSelectionChange)="selectClient(client)"
                  >
                    {{ client.company_name }}
                  </mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>

            <div class="progressivo-container">
              <mat-form-field>
                <mat-label>Numero</mat-label>
                <input
                  [minlength]="3"
                  [maxlength]="3"
                  matInput
                  formControlName="progressivo_numero"
                />
              </mat-form-field>
              <span>/SDI</span>
            </div>
          </div>

          <div class="document-row">
            <mat-form-field>
              <mat-label>Data</mat-label>
              <input
                matInput
                [matDatepicker]="picker"
                formControlName="data"
                appDateInput
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="picker"
              ></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>

            <mat-form-field>
              <mat-label>Descrizione</mat-label>
              <input matInput formControlName="riferimento" />
            </mat-form-field>

            <div class="empty-field"></div>
          </div>
        </div>
      </section>

      <!-- Linee Documento Section -->
      <section class="linee-documento">
        <h3>Linee Documento</h3>
        @if (invoiceForm.get("escludi_bollo")?.value === true) {
          <mat-slide-toggle
            formControlName="escludi_bollo"
            style="margin-bottom: 0.5rem"
            >Escludi Bollo</mat-slide-toggle
          >
        }
        <div class="table-container">
          <table>
            <thead>
              <tr>
                @for (col of displayedColumns; track col) {
                  <th class="{{ col }}">
                    {{ col }}
                  </th>
                }
              </tr>
            </thead>
            <tbody formArrayName="linee_documento">
              @for (
                line of documentLinesFormArray.controls;
                track line;
                let i = $index
              ) {
                <tr [formGroupName]="i">
                  <td>
                    <input
                      matInput
                      formControlName="descrizione"
                      [maxLength]="1000"
                    />
                  </td>
                  <td>
                    <input matInput formControlName="quantita" type="number" />
                  </td>
                  <td>
                    <input
                      matInput
                      formControlName="prezzo"
                      type="number"
                      min="0"
                      step="0.01"
                      placeholder="€"
                      (keydown.enter)="$event.preventDefault()"
                    />
                  </td>
                  <td>
                    <mat-select formControlName="iva_option">
                      @for (option of ivaOptions; track option) {
                        <mat-option [value]="option.split(':')[0]">
                          {{ option }}
                        </mat-option>
                      }
                    </mat-select>
                  </td>
                  <td><input matInput formControlName="totale" readonly /></td>
                  <td>
                    <button
                      mat-icon-button
                      type="button"
                      (click)="removeDocumentLine(i)"
                      [disabled]="
                        line
                          .get('descrizione')
                          ?.value.startsWith('Imposta di Bollo')
                      "
                    >
                      <mat-icon>delete</mat-icon>
                    </button>
                  </td>
                </tr>
              }
            </tbody>
          </table>
          <button
            mat-raised-button
            color="secondary"
            (click)="addDocumentLine()"
            [disabled]="fieldsDisabled"
          >
            Nuova Linea
          </button>
        </div>
      </section>

      <!-- Cassa Previdenza Section -->
      <section class="cassa-previdenza">
        <h4>Cassa Previdenza</h4>
        <mat-form-field>
          <mat-label>Tipologia Cassa</mat-label>
          <mat-select formControlName="tipologia_cassa">
            @for (option of tipologiaCassaOptions; track option) {
              <mat-option [value]="option.code">
                {{ option.description }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <mat-label>% Cassa</mat-label>
          <input matInput formControlName="percentuale_cassa" />
        </mat-form-field>
        <mat-form-field>
          <mat-label>IVA</mat-label>
          <mat-select formControlName="cassa_previdenza_codice_iva">
            @for (option of ivaOptions; track option) {
              <mat-option [value]="option.split(':')[0]">
                {{ option }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </section>

      <!-- Bottom Section -->
      <div class="bottom-container">
        <!-- Dati Pagamento Section -->
        <section class="dati-pagamento">
          <h3>Dati Pagamento</h3>
          <mat-form-field>
            <mat-label>Scadenza</mat-label>
            <mat-select formControlName="scadenza">
              <mat-option value="Vista fattura">Vista fattura</mat-option>
              <mat-option value="3 giorni">a 3 giorni</mat-option>
              <mat-option value="7 giorni">a 7 giorni</mat-option>
              <mat-option value="14 giorni">a 14 giorni</mat-option>
              <mat-option value="30 giorni">a 30 giorni</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field>
            <mat-label>Pagamento</mat-label>
            <mat-select formControlName="pagamento">
              <mat-option value="Carta di Pagamento"
                >Carta di Pagamento</mat-option
              >
              <mat-option value="Bonifico">Bonifico</mat-option>
              <mat-option value="Contanti">Contanti</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field>
            <mat-label>Banca</mat-label>
            <mat-select formControlName="doctor_bank_name">
              @for (bank of bankNameOptions; track bank) {
                <mat-option [value]="bank">
                  {{ bank }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-form-field>
            <mat-label>IBAN</mat-label>
            <mat-select formControlName="doctor_bank_iban">
              @for (iban of bankIbanOptions; track iban) {
                <mat-option [value]="iban">
                  {{ iban }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </section>

        <!-- Totals Section -->
        <section class="totals-section">
          <div class="total-row">
            <span class="label">{{
              (doctorFiscalProfile &&
                doctorFiscalProfile.regime_fiscale &&
                doctorFiscalProfile.regime_fiscale !== "RF19") ||
              invoiceForm.get("escludi_bollo")?.value
                ? "Imponibile:"
                : "Imponibile (incluso bollo):"
            }}</span>
            <span class="value"
              >{{ invoiceForm.get("imponibile")?.value || "0.00" }} €</span
            >
          </div>
          <div class="total-row">
            <span class="label">Cassa Previdenza:</span>
            <span class="value"
              >{{
                invoiceForm.get("totale_cassa_previdenza")?.value || "0.00"
              }}
              €</span
            >
          </div>
          <div class="total-row">
            <span class="label">Imposta:</span>
            <span class="value"
              >{{ invoiceForm.get("imposta")?.value || "0.00" }} €</span
            >
          </div>
          @if (
            doctorFiscalProfile &&
            doctorFiscalProfile.regime_fiscale &&
            doctorFiscalProfile.regime_fiscale !== "RF19"
          ) {
            <div class="total-row">
              <span class="label">Bollo:</span>
              <span class="value"
                >{{ invoiceForm.get("bollo")?.value || "0.00" }} €</span
              >
            </div>
          }
          @if (
            doctorFiscalProfile &&
            doctorFiscalProfile.regime_fiscale &&
            doctorFiscalProfile.regime_fiscale === "RF01"
          ) {
            <div class="total-row">
              <span class="label">Ritenuta:</span>
              <span class="value"
                >-{{
                  invoiceForm.get("totale_ritenuta")?.value || "0.00"
                }}
                €</span
              >
            </div>
          }
          <div class="total-row total">
            <span class="label">Totale:</span>
            <span class="value"
              >{{ invoiceForm.get("totale")?.value || "0.00" }} €</span
            >
          </div>
        </section>
      </div>

      <!-- Buttons -->
      <div class="panel-buttons">
        <button
          class="button-white"
          mat-stroked-button
          type="button"
          (click)="onCancel()"
        >
          Annulla
        </button>
        <button
          class="button-white"
          mat-stroked-button
          color="primary"
          type="button"
          (click)="onSaveDispatcher('draft')"
          [disabled]="!canSaveDraft"
        >
          Salva Bozza
        </button>
        <button
          class="button-white"
          mat-stroked-button
          color="primary"
          type="button"
          (click)="onSaveDispatcher('ready')"
          [disabled]="!canSaveDraft"
        >
          Salva Pronta
        </button>
      </div>
    </form>
  </div>
</div>
